import "./App.css";
import { Fragment } from "react";
import "./component/Home/Home";
import Home from "./component/Home/Home";
import Navs from "./component/Navs/Navs";
import Footer from "./component/Footer/Footer";

function App() {
  return (
    <Fragment>
      <Navs />
      <Home />
      <Footer />
    </Fragment>
  );
}

export default App;
